import React from "react";
import { motion } from "framer-motion";
import SEO from "../components/SEO";
import { useLanguage } from "../context/LanguageContext";

export default function About() {
    const { t } = useLanguage();

    const fadeIn = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.3, duration: 0.8, ease: "easeOut" }
        })
    };

    return (
        <div className="min-h-screen bg-[#f8f8f8] dark:bg-[#0a0a0a] text-gray-800 dark:text-gray-200 font-sans selection:bg-brand-blue/20 selection:text-brand-blue flex items-center justify-center">
            <SEO 
              title={t("nav_about")} 
              description={t("about_intro")} 
              url="/about" 
            />
            <main className="max-w-3xl mx-auto px-8 py-32 md:py-48 text-center space-y-24">

                {/* Title */}
                <motion.div
                    custom={0}
                    initial="hidden"
                    animate="visible"
                    variants={fadeIn}
                    className="space-y-6"
                >
                    <h1 className="text-4xl md:text-5xl font-light tracking-wide text-gray-900 dark:text-white">
                        {t("about_quiet")} <span className="font-serif italic text-gray-500">{t("about_rebellion")}</span>
                    </h1>
                </motion.div>

                {/* Core Philosophy */}
                <motion.div
                    custom={1}
                    initial="hidden"
                    animate="visible"
                    variants={fadeIn}
                    className="space-y-12 leading-relaxed text-lg md:text-xl font-light text-gray-600 dark:text-gray-400"
                >
                    <p>
                        {t("about_intro")}
                    </p>

                    <p>
                        {t("about_exhaustion")}
                        <br /><br />
                        {t("about_space")}{" "}
                        {t("about_you") && (
                            <span className="text-gray-900 dark:text-white font-normal">{t("about_you")}</span>
                        )}
                        {(!t("about_you")) && "."}
                    </p>
                </motion.div>

                {/* Values */}
                <motion.div
                    custom={2}
                    initial="hidden"
                    animate="visible"
                    variants={fadeIn}
                    className="space-y-8"
                >
                    <div className="w-px h-16 bg-gradient-to-b from-transparent via-gray-300 dark:via-gray-700 to-transparent mx-auto"></div>

                    <div className="space-y-4">
                        <h2 className="text-2xl font-serif text-gray-900 dark:text-white">{t("about_philosophy_title")}</h2>
                        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-xl mx-auto leading-relaxed">
                            {t("about_philosophy_body")}
                        </p>
                    </div>
                </motion.div>

                {/* Footer Signature */}
                <motion.div
                    custom={3}
                    initial="hidden"
                    animate="visible"
                    variants={fadeIn}
                    className="pt-16 opacity-60 hover:opacity-100 transition-opacity"
                >
                    <p className="text-sm tracking-widest uppercase text-gray-400 dark:text-gray-600">
                        {t("about_version")}
                    </p>
                </motion.div>

            </main>
        </div>
    );
}
